import api from 'services/api'
import {
  GET_FAMILY_MEMBERS_LIST,
  DELETE_FAMILY_MEMBER,
  CREATE_FAMILY_MEMBER,
  UPDATE_FAMILY_MEMBER,
  GET_FAMILY_MEMBER_DETAIL,
} from '../endpoints'

export const getFamilyMembersList = async (body) => await api.post(GET_FAMILY_MEMBERS_LIST, body)
export const deleteFamilyMember = async (id) => await api.delete(DELETE_FAMILY_MEMBER, {data: {id}})

export const submitFamilyMember = async (values, id) =>
  await api.post(id ? UPDATE_FAMILY_MEMBER : CREATE_FAMILY_MEMBER, values)

export const getFamilyMemberDetail = async (family_member_id) =>
  await api.get(`${GET_FAMILY_MEMBER_DETAIL}?family_member_id=${family_member_id}`)
